<img [src]="imgSrc" [class.defaultstyle]="defaultSrc" />
